import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import * as Sentry from "@sentry/angular";
import packageInfo from '../package.json'

if (environment.production) {
  enableProdMode();
}


Sentry.init({
  dsn: environment.sentry,
  sendDefaultPii: true,
  integrations: [
    Sentry.httpClientIntegration(),
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: ["localhost", /^\//],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  release: `passer-des-${packageInfo.version}`,
  attachStacktrace: true,
  enableLogs: true,
  ignoreErrors: [
    'ExpressionChangedAfterItHasBeenCheckedError',
    'NG0100',
  ],
  beforeSend(event) {
    const exception = event.exception?.values?.[0];

    if (
      exception?.value === '[object Boolean]' ||
      exception?.type === 'UnhandledPromiseRejection'
    ) {
      return null;
    }

    return event;
  }
});

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
